module.exports = __webpack_public_path__ + "assets/img/TikTok.c77f3eb5.png";